<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Expense Type</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Expense Type</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Expense Type</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Type Name</th>
                      <th>GL Account</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in expenseTypes"
                      v-bind:key="item.id"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.glAccount }}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectExpenseType(item)"
                              data-target="#edit_termination_type"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectExpenseType(item)"
                              data-target="#delete_department"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div
          id="add_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Expense Type</h5>
                <button
                  type="button"
                  class="close"
                  id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Type Name <span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.name.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      type="text"
                    />
                    <input
                      v-model.trim="$v.glAccount.$model"
                      id="glAccount"
                      name="glAccount"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.glAccount.$error }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      ExpenseType name is required
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div
          id="edit_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Expense Type</h5>
                <button
                  type="button"
                  class="close"
                  id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Type Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="expenseType.name"
                    id="expenseType.name"
                    name="expenseType.name"
                    class="form-control"
                  />
                  <input
                    type="text"
                    v-model="expenseType.glAccount"
                    id="expenseType.glAccount"
                    name="expenseType.glAccount"
                    class="form-control"
                  />
                </div>
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_department"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Expense Type</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="onDeleteSubmit"
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        data-dismiss="modal"
                        id="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },

  data() {
    return {
      name: "",
      glAccount: "",
      expenseType: {},
      expenseTypes: [],
      submitted: false,
      loading: false,
      error: "",
      company: authenticationService.currentOfficeValue
    };
  },

  validations: {
    name: { required },
    glAccount: { required }
  },

  methods: {
    selectExpenseType(item) {
      this.expenseType = item;
    },

    getExpenseTypes() {
      employeeService.getExpenseType(this.company.id).then(
        model => {
          this.expenseTypes = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      //console.log(this.name)
      employeeService.addExpenseType(this.company.id, this.name, this.glAccount).then(
        id => {
          employeeService.getExpenseType(this.company.id).then(r => {
            this.expenseTypes = r;
            this.name = "";
            this.glAccount = "";
            console.log(r);
            $("#close").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      console.log(this.expenseType);
      this.loading = true;
      employeeService.updateExpenseType(this.expenseType).then(
        id => {
          employeeService.getExpenseType(this.company.id).then(r => {
            this.expenseTypes = r;
            $("#closeEdit").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onDeleteSubmit() {
      console.log(this.expenseType);
      this.loading = true;
      employeeService.removeExpenseType(this.expenseType.id).then(
        id => {
          employeeService.getExpenseType(this.company.id).then(r => {
            this.expenseTypes = r;
            $("#closeDelete").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getExpenseTypes();
    //this.removeSkillType(this.company.id);
    // Datatable

    // if ($(".datatable").length > 0) {
    //   $(".datatable").DataTable({
    //     bFilter: false,
    //   });
    // }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "terminationtype"
};
</script>



// WEBPACK FOOTER //
// src/components/settings/expenseType.vue